const CommonAction = {
    GET_BANNER: 'GET_BANNER',
    SET_BANNER: 'SET_BANNER',
    SET_LOADER: 'SET_LOADER',
    GET_MANAGEMENT: 'GET_MANAGEMENT',
    SET_MANAGEMENT: 'SET_MANAGEMENT',
    NAV_LINKS: 'NAV_LINKS',
    SET_TOASTER: 'SET_TOASTER'
}
export default CommonAction